import $ from 'jquery'

if($('#input_1_12').length !== 0) {
 $('#input_1_12').val(sessionStorage.getItem('product_name'))
}
